export const toggle_open_menu = 'toggle_open_menu';
export const set_open_menu = 'set_open_menu';

export function openLeftMenu() {
    return {
        type: toggle_open_menu,
    };
}

export function setOpenMenu(data) {
    return {
        type: set_open_menu,
        data,
    };
}
